// src/catalog.ts
var PRODUCT_KEY_VALET_LITE = "valet-lite";
var PRODUCT_KEY_VALET_FULL_SERVICE = "valet-full-service";
var PRODUCT_KEY_OPERATIONAL_MOVES = "operational-moves";
var PRODUCT_KEY_GUEST_RIDES = "guest-rides";
var PRODUCT_KEY_MOBILE_SERVICE = "mobile-service";
var PRODUCT_KEY_PARTS_DELIVERY = "parts-delivery";
var PRODUCT_KEY_ENTERPRISE = "enterprise";
var PRODUCT_KEY_APPRAISALS = "appraisals";
var PRODUCT_KEY_RETURN_RIDES = "return-rides";
var USECASE_KEY_GUEST_RIDESHARE = "guest-rideshare";
var USECASE_KEY_MOBILE_SERVICE_RUN = "mobile-service-run";
var USECASE_KEY_PARTS_DELIVERY_ROUTE = "parts-delivery-route";
var PRODUCT_DEFINITIONS = [
  {
    key: PRODUCT_KEY_VALET_LITE,
    label: "Valet Lite",
    description: "Software for dealerships to manage vehicle moves with their own drivers."
  },
  {
    key: PRODUCT_KEY_VALET_FULL_SERVICE,
    label: "Valet Full Service",
    description: "Vehicle pickup and delivery performed by HopDrive drivers."
  },
  {
    key: PRODUCT_KEY_OPERATIONAL_MOVES,
    label: "Operational Moves",
    description: "Vehicle move operations and coverage across Valet services."
  },
  {
    key: PRODUCT_KEY_GUEST_RIDES,
    label: "Guest Rides",
    description: "Rideshare transportation for dealership guests and customers."
  },
  {
    key: PRODUCT_KEY_MOBILE_SERVICE,
    label: "Mobile Service",
    description: "Management of mobile service visits away from the dealership."
  },
  {
    key: PRODUCT_KEY_PARTS_DELIVERY,
    label: "Parts Delivery",
    description: "Delivery of automotive parts between dealerships and service locations."
  },
  {
    key: PRODUCT_KEY_ENTERPRISE,
    label: "Enterprise",
    description: "Program-level vehicle transportation for enterprise operations."
  },
  {
    key: PRODUCT_KEY_APPRAISALS,
    label: "Appraisals",
    description: "Vehicle appraisals based on vehicle details and condition."
  },
  {
    key: PRODUCT_KEY_RETURN_RIDES,
    label: "Return Rides",
    description: "Separately purchased rideshare transportation that returns stranded dealership drivers after one-way Valet Lite moves."
  }
];
var SALABLE_PRODUCT_KEYS = PRODUCT_DEFINITIONS.map(
  ({ key }) => key
);
function getProductDefinition(productKey) {
  return PRODUCT_DEFINITIONS.find(({ key }) => key === productKey);
}
function productLabel(productKey) {
  return getProductDefinition(productKey)?.label ?? productKey;
}

export {
  PRODUCT_KEY_VALET_LITE,
  PRODUCT_KEY_VALET_FULL_SERVICE,
  PRODUCT_KEY_OPERATIONAL_MOVES,
  PRODUCT_KEY_GUEST_RIDES,
  PRODUCT_KEY_MOBILE_SERVICE,
  PRODUCT_KEY_PARTS_DELIVERY,
  PRODUCT_KEY_ENTERPRISE,
  PRODUCT_KEY_APPRAISALS,
  PRODUCT_KEY_RETURN_RIDES,
  USECASE_KEY_GUEST_RIDESHARE,
  USECASE_KEY_MOBILE_SERVICE_RUN,
  USECASE_KEY_PARTS_DELIVERY_ROUTE,
  PRODUCT_DEFINITIONS,
  SALABLE_PRODUCT_KEYS,
  getProductDefinition,
  productLabel
};
//# sourceMappingURL=chunk-7LRMHEXV.mjs.map